import React from 'react';
import styles from './LobbyDetails.module.css';

interface LobbyDetailsProps {
  lobby: {
    id: number;
    name: string;
    minLevel: number;
    maxLevel: number;
    maxPlayers: number;
    randomTeams: boolean;
    pve: boolean;
    matchType: string;
    isRanked?: boolean;
  };
}

const LobbyDetails: React.FC<LobbyDetailsProps> = ({ lobby }) => (
  <div>
    <h2 className={styles.lobbylabel}>{lobby.name}</h2>
    <div className={styles.detailsGrid}>
      <div className={styles.detailChip}>
        <span className={styles.chipLabel}>Mode</span>
        <span className={styles.chipValue}>{lobby.isRanked ? '⚔ Ranked' : lobby.pve ? 'PvE' : 'PvP'}</span>
      </div>
      {!lobby.isRanked && (
        <div className={styles.detailChip}>
          <span className={styles.chipLabel}>Deathmatch</span>
          <span className={styles.chipValue}>{lobby.matchType === 'death' ? '💀 Yes' : 'No'}</span>
        </div>
      )}
      <div className={styles.detailChip}>
        <span className={styles.chipLabel}>Levels</span>
        <span className={`${styles.chipValue} ${styles.chipValueGold}`}>{lobby.minLevel} – {lobby.maxLevel}</span>
      </div>
      <div className={styles.detailChip}>
        <span className={styles.chipLabel}>Capacity</span>
        <span className={`${styles.chipValue} ${styles.chipValueGold}`}>{lobby.maxPlayers}</span>
      </div>
      <div className={styles.detailChip}>
        <span className={styles.chipLabel}>Teams</span>
        <span className={styles.chipValue}>{lobby.randomTeams ? 'Random' : 'Manual'}</span>
      </div>
    </div>
  </div>
);

export default LobbyDetails;
